import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { selectorIsRequirementWithApprovalFlow } from "./selectorIsRequirementWithApprovalFlow";

export const selectorIsRequirementPendingApproval = (
  requirement: IRequirementResponse
) => {
  const isApprovalStrategy = selectorIsRequirementWithApprovalFlow(requirement);

  const isPendingApprovalStatus =
    requirement.status === RequirementStatus.PendingReview;

  return isApprovalStrategy && isPendingApprovalStatus;
};
